import { FC } from 'react'
import { Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import {
  HasSidebarLayout,
  DataLoad,
  EntityHeader,
  BleConnectionLogInfo,
} from 'src/components'
import { useBleConnectionLogRequest } from 'src/hooks/api'
import { BleConnectionLog } from 'src/api'

interface BleConnectionLogShowContentProps {
  log?: BleConnectionLog
}

const BleConnectionLogShowContent: FC<BleConnectionLogShowContentProps> = ({ log }) => {
  if (!log) return null

  return (
    <Grid container>
      <Grid item xs={12}>
        <EntityHeader title={`BLE connection log #${log.id}`} />
      </Grid>
      <Grid item container xs={12}>
        <BleConnectionLogInfo log={log} />
      </Grid>
    </Grid>
  )
}

const BleConnectionLogShow: FC = () => {
  document.title = 'CLīMIT Admin Panel - BLE connection log'
  const params = useParams()
  const id = parseInt((params as { logId: string }).logId, 10)
  const { data, isInitialLoading, isError, error } = useBleConnectionLogRequest({ id })

  return (
    <HasSidebarLayout>
      <DataLoad
        isLoading={isInitialLoading}
        isError={isError}
        errorMessage={error?.message}
      >
        <BleConnectionLogShowContent log={data} />
      </DataLoad>
    </HasSidebarLayout>
  )
}

export default BleConnectionLogShow
